require('./bootstrap');

import Vue from 'vue'
import CreateAccountApp from './views/CreateAccount.vue';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import '../shared/directives/index';

Vue.config.productionTip = false

Vue.use(VueReCaptcha, {
  siteKey: document.querySelector('input[name=recaptcha_key]').value
});

Vue.component('input-field', require('./components/InputField.vue').default);

Vue.mixin({
  computed: {
    environment() {
      return window.LS_ENVIRONMENT;
    },
    appName() {
      return window.LS_APP_NAME;
    },
    appUrl(){
      return window.LS_APP_URL;
    },
    marketingUrl() {
      return window.LS_MARKETING_URL;
    },
    trialPeriod() {
      return window.LS_TRIAL_PERIOD;
    }
  }
})

/* eslint-disable no-new */
new Vue(CreateAccountApp);
